import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-brandOrange font-bold tracking-wider uppercase text-sm mb-2">About Us</h2>
            <h3 className="text-4xl font-extrabold text-royal mb-6">Building Confidence Behind the Wheel</h3>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              At Crossroads Driving School, we believe that learning to drive should be an exciting and enjoyable experience, not a stressful one. We specialize in automatic driving lessons, making it easier and faster for you to get on the road.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Whether you are a complete beginner or a nervous driver looking to regain your confidence, our friendly, patient, and highly structured approach ensures you learn at a pace that perfectly suits you.
            </p>
            <ul className="space-y-3 mb-8">
              {['Passionate & Patient Instructors', 'Modern Dual-Controlled Automatic Vehicles', 'Tailored Lesson Plans for Every Student'].map((item, index) => (
                <li key={index} className="flex items-center text-gray-800 font-semibold">
                  <span className="w-6 h-6 rounded-full bg-brandOrange text-white flex items-center justify-center mr-3 text-sm flex-shrink-0">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl relative z-10">
              <img src="https://i.postimg.cc/9fLmLd68/2026-03-29-16-13-04.jpg" alt="Happy student passing driving test" className="w-full h-auto object-cover" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-brandOrange rounded-2xl z-0"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;